import { createFileRoute } from "@tanstack/react-router"
import PlayerGroups from "@/app/settings/analysis-groups/players/page"

export const Route = createFileRoute("/settings/analysis-groups/players")({
  component: PlayerGroups,
})
